import moment from "moment";

// A track is considered "New" for this many days after its publish date.
// Used for the "New" tag badge, the New search filter, and the
// subscriber-only download gate (see utils/isNewTrack.js).
export const newTagAmountOfDays = 180;

export const newTagFilter = {
  name: "New",
  type: "dateRange",
  value: "publishDate",
  min: moment().subtract(newTagAmountOfDays, "days"),
  max: moment()
};
